/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportOk } from '../../models/export-ok';

export interface ExportCasesWithTourId$Params {

/**
 * Id of a resource.
 */
  id: string;
}

export function exportCasesWithTourId(http: HttpClient, rootUrl: string, params: ExportCasesWithTourId$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportOk>> {
  const rb = new RequestBuilder(rootUrl, exportCasesWithTourId.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportOk>;
    })
  );
}

exportCasesWithTourId.PATH = '/api/v1/export/tour/{id}';
